namespace GeniuzPOS.AdvPromo {
    export interface LookupAvPromoCouponTypesRow {
        Id?: string;
        EndBillPmType?: number;
        CouponTypeLookup?: string;
        CouponType?: string;
        CpName?: string;
        CpNameF?: string;
    }

    export namespace LookupAvPromoCouponTypesRow {
        export const idProperty = 'CouponTypeLookup';
        export const nameProperty = 'CpNameF';
        export const localTextPrefix = 'AdvPromo.LookupAvPromoCouponTypes';
        export const lookupKey = 'AdvPromo.LookupAvPromoCouponTypes';

        export function getLookup(): Q.Lookup<LookupAvPromoCouponTypesRow> {
            return Q.getLookup<LookupAvPromoCouponTypesRow>('AdvPromo.LookupAvPromoCouponTypes');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            EndBillPmType = "EndBillPmType",
            CouponTypeLookup = "CouponTypeLookup",
            CouponType = "CouponType",
            CpName = "CpName",
            CpNameF = "CpNameF"
        }
    }
}
